module.exports = __webpack_public_path__ + "img/2008_L.05a7a7ae.png";